import React from 'react';
import PropTypes from 'prop-types';
import {
    createStore,
    applyMiddleware,
    compose,
} from 'redux';
import thunk from 'redux-thunk';
import { reduxBatch } from '@manaflair/redux-batch';
import { Provider } from 'react-redux';
import popularWidgetReducer from './reducers/popularWidgetReducers';
import PopularWidgetContainer from './PopularWidgetContainer';
import './styles/popularwidget.scss';

const store = createStore(
    popularWidgetReducer,
    {},
    compose(applyMiddleware(thunk), reduxBatch)
);

const PopularWidget = ({ source = '' }) => {
    return (
        <Provider store={store}>
            <PopularWidgetContainer source={source}/>
        </Provider>
    );
};

PopularWidget.propTypes = {
    source: PropTypes.string,
};

export default PopularWidget;
